import { MutationTree, Mutation } from 'vuex';
import { ISearchHit, ISearchResult, IState } from './state';
import { ActionPayload, IToggleFilterPayload } from './actions';

export interface ShouldFocusPayload {
	shouldFocus: boolean,
	index: number
}

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}
const decreasePageMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, {currentPage: state.currentPage - 1});
}
const increasePageMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, {currentPage: state.currentPage + 1});
}
const setHitsMutation: MutationHandler<ISearchHit[]> = (state, { payload }) => {
	state.searchResult.searchHits = payload
}
const addHitsMutation: MutationHandler<ISearchHit[]> = (state, { payload }) => {
	state.searchResult.searchHits.push(...payload)
}
const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload
}
const newSearchMutation: MutationHandler<ISearchResult> = (state, { payload }) => {
	state.currentPage = 0;
	state.searchResult = payload;
}
const shouldFocusMutation: MutationHandler<ShouldFocusPayload> = (state, { payload }) => {
	state.focus = payload
}
const setSearchedQueryMutation: MutationHandler<ShouldFocusPayload> = (state, { payload }) => {
	state.searchedQuery = state.query;
}
const setSuggestionMutation: MutationHandler<string> = (state, { payload }) => {
	state.suggestion = payload
}
const setActivePageMutation: MutationHandler<number> = (state, { payload }) => {
	state.currentPage = payload
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	decreasePage: decreasePageMutation,
	increasePage: increasePageMutation,
	setHits: setHitsMutation,
	addHits: addHitsMutation,
	setQuery: setQueryMutation,
	newSearch: newSearchMutation,
	shouldFocus: shouldFocusMutation,
	setSearchedQuery: setSearchedQueryMutation,
	setSuggestion: setSuggestionMutation,
	setActivePage: setActivePageMutation
}

export default mutations
